export const investigationTypes = [
    {
        name: "Fiscal",
        value: "fiscal"
    },
    {
        name: "Sancionatoria",
        value: "sancionatoria"
    },
    {
        name: "Disciplinaria",
        value: "disciplinaria"
    }
];

export const links = [
    {
        name: "Poder especial",
        value: "poder"
    },
    {
        name: "Solicitud afectación poliza",
        value: "poliza"
    },
    {
        name: "Estrategia de defensa",
        value: "estrategia"
    },
    {
        name: "Propuesta de honorarios",
        value: "honorarios"
    }
];

export const placeholders = {
    summary: 'Ej: El presente caso se origina con ocasión al hallazgo 46 de la "Auditoría Financiera y de Gestión al distrito de Santiago de Cali, incluye Concejo Municipal Vigencia 2020", predio denominado "El Arbolito", donde se constató que el mencionado puesto de control fue contratado y pagado por el Dagma ante la grave situación que está el parque nacional que enfrenta diversas problemáticas ambientales que incluyen temas como ocupación ilegal, extracción de recursos de fauna y flora, cultivos ilícitos entre otras, con base  en visita que realizó la Contraloría General de Santiago de Cali el 12 de Marzo de 2021 a la obra en mención, donde evidenció que la misma no está terminada y por consiguiente no se encuentra en funcionamiento, por lo anterior no se logró el objeto contractual, lo configuraría un presunto detrimento patrimonial por $ 1.990.299,061.',
    observation: 'Ej: por traslado realizado por la Contraloría Municipal de Cali dentro del informe denominado “AGEI REGULAR AL MUNICIPIO DE SANTIAGO DE CALI (INCLUYE CONCEJO MUNICIPAL) VIGENCIA 2019”, estableciendo el hallazgo No. 53 con presunta incidencia fiscal.',
    events: 'Ej: El presente caso se origina con ocasión al hallazgo fiscal No. 53, dentro del informe denominado “AGEI REGULAR AL MUNICIPIO DE SANTIAGO DE CALI (INCLUYE CONCEJO MUNICIPAL) VIGENCIA 2019”, que se apertura por el contrato de prestación de servicios profesionales No. 4151.010.26.1.931.2019 de Lourdes Salamanca, asesora de la secretaria de infraestructura, quien según la contraloría no cumplía con los requisitos de idoneidad para ser asesora y no haber sido contratada conforme a la tabla de honorarios de P.S. generando un presunto detrimento patrimonial por $23.270.048.',
    cali: {
        amount: 'Ej (Cali): Presupuesto: CUATRO BILLONES SEISCIENTOS MIL SEISCIENTOS OCHENTA MILLONES TRESCIENTOS CINCUENTA Y OCHO MIL QUINIENTOS TREINTA Y OCHO PESOS ($ 4.600.680.358.538)\r\nMínima cuantía: CIEN MILLONES DE PESOS ($100.000.000)\r\nMenor cuantía: HASTA MIL MILLONES DE PESOS ($1.000.000.000,00)\r\nMayor cuantía: Todo lo que supere la menor cuantía. (>1.000.000.000,00)',
        instances: 'Ej (Cali): Única Instancia: = o < 1.000.000.000,00 (Igual o menor a mil millones de pesos)\r\nDoble instancia: Todo lo que supere MIL MILLONES DE PESOS. (>1.000.000.000,00)'
    },
    palmira: {
        amount: 'Ej (Palmira): Presupuesto:  QUINIENTOS OCHENTA Y SEIS MIL VEINTIOCHO MILLONES QUINIENTOS SETENTA MIL QUINIENTOS NOVENTA Y TRES PESOS ($586.028.570.593)\r\nMínima cuantía: SESENTA Y CINCO MILLONES ($65.000.000)\r\nMenor cuantía: HASTA SEISCIENTOS CINCUENTA MILLONES ($650.000.000)\r\nMayor cuantía: Todo lo que supere 650 millones de pesos (>650.000.000)',
        instances: 'Ej (Palmira): Única instancia: = o < a 650.000.000 (Igual o menor a seiscientos cincuenta millones)\r\nDoble instancia: Todo lo que supere 650 millones de pesos. (>650.000.000)'
    },
    proof: 'El documento debe tener indicación y valoración de las pruebas practicadas.: si se trata de un auto de apertura e imputación, este debe señalar las pruebas en las que se basan para imputar, también debe estimar cómo las valoraron. Si esto no se observa, dejar la anotación',
    elementsOfDamage: 'En los casos de auto de imputación de responsabilidad fiscal, deben acreditar con hechos y argumentos jurídicos cada uno de los elementos de responsabilidad fiscal.',
    recusation: 'Artículo 130 Ley 1437 de 2011, Importante tener presente si en los hechos que dan origen la causa de la investigación está inmerso algún funcionario que a su vez hace parte de quien investiga y juzga, como por ejemplo:\r\nObservar si algún miembro del equipo auditor está dentro de la mesa de funcionarios que gestionan la audiencia.',
    nullity: 'Tener presente los elementos imprescindibles y taxativos de los autos de apertura, señalar si falta alguno para alegar causal de nulidad.',
    expiration: 'Contar los términos que tiene para fallar el ente. Artículos 9 Ley 610 y Artículo 30 ley 734. Artículo 33 Ley 2094, se pondrían los años o el tiempo que tiene el juzgador para fallar antes de perder competencia',
    foisted: 'Aterrizarla describiéndola, pero no con detalle sino con lo esencial, resumen de la causa y conducta endilgada así como la calificación de la misma.'
};

export const values = [
    {
        name: "Sin honorarios",
        valueLetters: "SIN HONORARIOS",
        valueNumber: "0"
    },
    {
        name: "5 Millones",
        valueLetters: "CINCO MILLONES DE PESOS MCTE",
        valueNumber: "5000000"
    },
    {
        name: "10 Millones",
        valueLetters: "DIEZ MILLONES DE PESOS MCTE",
        valueNumber: "10000000"
    },
    {
        name: "16 Millones",
        valueLetters: "DIECISEIS MILLONES DE PESOS MCTE",
        valueNumber: "16000000"
    },
    {
        name: "20 Millones",
        valueLetters: "VEINTE MILLONES DE PESOS MCTE",
        valueNumber: "20000000"
    },
    {
        name: "30 Millones",
        valueLetters: "TREINTA MILLONES DE PESOS MCTE",
        valueNumber: "30000000"
    }
];

export const templateData = {
    type: 'PODER ESPECIAL',
    company: {
        address: 'Calle 15 N No. 6N- 34 Oficina 401 Edificio Alcazar',
        phone: 'Teléfono:  (602)4074950',
        city: 'Cali - Colombia',
    }
};

export const territorialEntity = [
	"Alcaldía",
	"Área Metropolitana",
	"Asamblea Departamental",
	"Asociación",
	"Asociación de Municipios",
	"Auditoría General de la República",
	"Banco de la República",
	"Compañia de Financiamiento",
	"Concejo Municipal",
	"Contaduría General de la Nación",
	"Contraloría General de la República",
	"Cooperativa",
	"Cooperativa Financiera",
	"Corporacion de Ahorro y Vivienda",
	"Corporacion Financiera",
	"Defensoría del Pueblo",
	"Departamento Administrativo",
	"Distrito",
	"Empresa Industrial y Comercial del Estado",
	"Entidad Territorial Indigena",
	"Establecimiento Bancario",
	"Establecimiento Publico",
	"Fundacion",
	"Gobernación",
	"Ministerio",
	"Procuraduría General de la Nación",
	"Sindicato",
	"Sociedad Anonima Abierta",
	"Sociedad Anonima Cerrada",
	"Sociedad Anonima Especial",
	"Sociedad Anonima Mixta",
	"Sociedad Anonima",
	"Sociedad Colectiva",
	"Sociedad Comercial de Hecho",
	"Sociedad Comercial Unipersonal",
	"Sociedad de Economia Mixta",
	"Sociedad de Familia",
	"Sociedad de Responsabilidad Limitada",
	"Sociedad en Comandita por Acciones",
	"Sociedad en Comandita Simple",
	"Sociedad en Comandita",
	"Sociedad Extranjera",
	"Sociedad por Acciones Simplificada",
	"Superintendencia"
];

export const legalityTypes = [
    {
        name: "Auto de apertura",
        value: "autoOpening"
    },
    {
        name: "Imputación",
        value: "imputation"
    }
];

export const adminCasesTableHeaders = [
    "Fecha",
    "Radicado",
    "Tipo Inv.",
    "Abogado",
    "Cliente",
    "Detalles",
    "Empresa",
    "Estado",
];

export const adminCasesTableBody = [
    {
        data: "formattedDate",
        classname: "inline-text"
    },
    {
        data: "filingNumber",
        classname: "inline-text"
    },
    {
        data: "caseType",
        classname: ""
    },
    {
        data: "attorneyText",
        classname: ""
    },
    {
        data: "clientText",
        classname: ""
    },
    {
        data: "details",
        classname: ""
    },
    {
        data: "legalCompany",
        classname: ""
    },
    {
        data: "status",
        classname: ""
    },
];

export const userCasesTableHeaders = [
    "Fecha",
    "Radicado",
    "Tipo Inv.",
    "Abogado",
    "Cliente",
    "Detalles"
];

export const userCasesTableBody = [
    {
        data: "formattedDate",
        classname: "inline-text"
    },
    {
        data: "filingNumber",
        classname: "inline-text"
    },
    {
        data: "caseType",
        classname: ""
    },
    {
        data: "attorneyText",
        classname: ""
    },
    {
        data: "clientText",
        classname: ""
    },
    {
        data: "details",
        classname: ""
    },
];

export const CASE_STATUSES = {
    "not checked": "Sin revisar",
    "checked": "Revisado",
    "finished": "Terminado",
}

export const CASE_INSTANCES = {
    "única": "Única",
    "doble": "Doble",
}

export const casesYears = [
    "2022",
    "2023",
    "2024",
    "2025",
    "2026",
]